import { C, L10N } from '../common';

export default ({ language } = {}) => ({ l10n: L10N[language] || L10N[C.LANGUAGE] });
